import classNames from 'classnames';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import React, { useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import PhoneInput from 'react-phone-input-2';
import ReactSelect from 'react-select';

const phoneNumberObj = {
  id: 1,
  phoneNumber: '',
  numberType: { value: 'personal', label: 'Personal' },
  isDefault: true
};

export const numberTypeOptions = [
  { value: 'personal', label: 'Personal' },
  { value: 'home', label: 'Home' },
  { value: 'office', label: 'Office' },
  { value: 'office_2', label: 'Office 2' }
];

const PhoneNumberInputs = () => {
  const [phoneNumber, setPhoneNumber] = useState();
  const [phoneNumbers, setPhoneNumbers] = useState([{ ...phoneNumberObj }]);

  const handleInputChange = (value, id) => {
    const allPhoneNumbers = [...phoneNumbers];
    const selectedIndex = allPhoneNumbers.findIndex(phone => phone.id === id);

    if (selectedIndex > -1) {
      const selectedPhone = allPhoneNumbers[selectedIndex];
      selectedPhone.phoneNumber = value.trimStart();
      setPhoneNumbers(allPhoneNumbers);
      setPhoneNumber(value.trimStart());
    }
  };

  const addPhoneNumbersHandler = () => {
    const prePhoneNumbers = [...phoneNumbers];
    const newPhoneNumber = { ...phoneNumberObj };
    const lastAddressId = prePhoneNumbers[prePhoneNumbers.length - 1].id;
    newPhoneNumber.id = lastAddressId + 1;
    newPhoneNumber.isDefault = false;
    prePhoneNumbers.push(newPhoneNumber);
    setPhoneNumbers(prePhoneNumbers);
  };

  const setAddDefaultPhone = id => {
    const allPhoneNumbers = [...phoneNumbers];
    const selectedIndex = allPhoneNumbers.findIndex(phone => phone.id === id);
    const preDefaultPhoneIndex = allPhoneNumbers.findIndex(
      phone => phone.isDefault
    );

    if (selectedIndex > -1 && !allPhoneNumbers[selectedIndex].defaultAddress) {
      const preSelectedPhone = allPhoneNumbers[preDefaultPhoneIndex];
      const selectedPhoneNumber = allPhoneNumbers[selectedIndex];
      preSelectedPhone.isDefault = false;
      selectedPhoneNumber.isDefault = true;
      setPhoneNumbers(allPhoneNumbers);
    }
  };

  const changeNumberTypeHandler = (value, id) => {
    const allPhoneNumbers = [...phoneNumbers];
    const selectedIndex = allPhoneNumbers.findIndex(phone => phone.id === id);
    if (selectedIndex > -1) {
      const selectedPhone = allPhoneNumbers[selectedIndex];
      selectedPhone.numberType = value;
      setPhoneNumbers(allPhoneNumbers);
    }
  };

  const deletePhoneHandler = id => {
    const allPhoneNumbers = [...phoneNumbers];
    const selectedIndex = allPhoneNumbers.findIndex(phone => phone.id === id);

    if (selectedIndex > -1) {
      allPhoneNumbers.splice(selectedIndex, 1);
      setPhoneNumbers(allPhoneNumbers);
    }
  };

  return (
    <Card className="mb-3">
      <Card.Header>
        <Card.Title className="fw-medium">Phone Number</Card.Title>
      </Card.Header>
      <Card.Body className="pb-1">
        <Row>
          {phoneNumbers.map((phone, index) => (
            <Col key={index} md={12}>
              <Form.Label>Country</Form.Label>

              <Row className="g-3">
                <Form.Group
                  as={Col}
                  md={6}
                  controlId={`phone-${1}`}
                  className="mb-3"
                >
                  <PhoneInput
                    defaultErrorMessage="Please enter valid phone number"
                    country="pk"
                    value={phone.phoneNumber}
                    onChange={data => handleInputChange(data, phone.id)}
                    placeholder="XXX XXX XXXX"
                    inputStyle={{ height: 38, width: '100%' }}
                    // isValid={phoneNumber?.length > 11}
                  />
                  <Form.Control
                    required
                    value={phone.phoneNumber}
                    onChange={() => {}}
                    name="contactPhoneNumber"
                    pattern="[0-9+]{11,13}"
                    className="d-none"
                  />
                  <Form.Control.Feedback type="invalid">
                    {!phone.phoneNumber
                      ? 'Required'
                      : phoneNumber?.length < 11 &&
                        'Please enter valid phone number'}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md={3}>
                  <ReactSelect
                    closeMenuOnSelect={true}
                    options={numberTypeOptions}
                    placeholder="Select"
                    classNamePrefix="react-select"
                    value={phone?.numberType}
                    onChange={value => changeNumberTypeHandler(value, phone.id)}
                  />
                  <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                </Form.Group>

                <Col md={3}>
                  <Flex justifyContent="between">
                    <Form.Group controlId={`phone-control-${phone.id}`}>
                      <div className="mt-2">
                        <Form.Check
                          inline
                          type="radio"
                          name="phoneNumberInputs"
                          id={`phone-control-${phone.id}`}
                          value={`phone-${phone.id}`}
                          className="me-2"
                          defaultChecked={phone.isDefault}
                          onClick={() => setAddDefaultPhone(phone.id)}
                        />
                        <Form.Label className="mb-0">
                          {phone.isDefault ? 'Primary' : ''}
                        </Form.Label>
                      </div>
                    </Form.Group>
                    <IconButton
                      variant="light"
                      icon="trash"
                      className={classNames(
                        'mb-1 bg-transparent border-0 shadow-none',
                        { 'v-hidden': phone.isDefault }
                      )}
                      iconAlign="left"
                      transform="shrink-3"
                      iconClassName="text-danger me-2"
                      onClick={() => deletePhoneHandler(phone.id)}
                      disabled={phone.isDefault}
                    >
                      Delete
                    </IconButton>
                  </Flex>
                </Col>
              </Row>
              {index !== phoneNumbers?.length - 1 && <hr className="my-2" />}
            </Col>
          ))}
        </Row>
      </Card.Body>
      <div className="p-3 pt-0">
        <Button
          variant="light"
          className="bg-transparent border-0 fs--1 fs-md-0 shadow-none text-primary p-1"
          onClick={addPhoneNumbersHandler}
        >
          Add New Phone Number
        </Button>
      </div>
    </Card>
  );
};

export default PhoneNumberInputs;
